export default __webpack_public_path__ + "static/media/1m-min.0a7d4821.jpg";